import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';

@Component({
  selector: 'app-company-sample-report-detials-page',
  templateUrl: './company-sample-report-detials-page.component.html',
  styleUrls: ['./company-sample-report-detials-page.component.scss']
})
export class CompanySampleReportDetialsPageComponent implements OnInit {
  pdfSampleURL:any;
  sku:any;
  productName
  productType: string;
  productDetails: any;
  loginEmail;
  plan;
  isAdvance;
  isPremium;
  isFree;
  deviceType: string;

  constructor(private companyService: CompanyService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService,
    private loginSignupService: LoginSignupService,) {
    this.deviceType = localStorage.getItem('deviceType');
    this.route.params.subscribe(
      (params) => {
        // this.companyName = params.name;
        // this.productName = params.report;
        // this.cin = this.localStorage.getItem(this.companyName);
        this.sku = params.sku.toUpperCase();
        this.productType = this.commonService.getProductTypeBySku(this.sku);
        this.productDetails = this.commonService.getProductDetailsByType(this.productType);
        // console.log('productDetails', this.productDetails);
        this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;
        this.plan = this.localStorage.getItem('plan');
        if (this.plan == 'plan_advance') {
          this.isAdvance = true;
        }
        if (this.plan == 'plan_premium') {
          this.isPremium = true;
        }
        this.isProductFree(this.plan);
        this.pdfSampleURL = this.commonService.getProductSampleUrlBySku(this.sku);
   
      }
    );
   }

  ngOnInit(): void {
  }

  isProductFree(plan) {
    this.isFree = false;
    if (this.loginEmail == undefined || this.loginEmail == '' || this.loginEmail == null) {
      this.isFree = false;
    } else {
      if (
        this.productDetails.type == 'BSS' ||
        this.productDetails.type == 'PLS' ||
        this.productDetails.type == 'ROC'
      ) {
        if (plan == 'free' || plan == 'plan_advance') {
          this.isFree = false;
        } else {
          this.isFree = true;
        }
      } else {
        this.isFree = false;
      }
    }
  }

}
